import React, { FormEvent, ChangeEvent } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { TextField } from "@material-ui/core";
import { SubmitButton } from "../../../input/component/submit_button/SubmitButton";
import { ThemeUtil } from "../../../util/ThemeUtil";
import "./AdminLoginForm.scss";

interface Props {
    onSubmit: (email: string, password: string) => void;
    error?: string;
    loading: boolean;
}

interface State {
    email: string;
    password: string;
}

export class AdminLoginForm extends React.Component<Props, State> {
    private readonly inputTheme = ThemeUtil.usingGlobalTheme({});

    constructor(props: Props) {
        super(props);
        this.state = { email: "", password: "" };
    }

    private handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
        this.setState({ email: e.target.value.trim() });
    };

    private handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
        this.setState({ password: e.target.value });
    };

    private handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        if (this.props.loading) return;
        const { email, password } = this.state;
        if (!email || !password) return;
        this.props.onSubmit(email, password);
    };

    render() {
        const { error, loading } = this.props;
        const { email, password } = this.state;
        const canSubmit = Boolean(email && password && !loading);

        return (
            <div className="admin-login-form">
                <form onSubmit={this.handleSubmit}>
                    <ThemeProvider theme={this.inputTheme}>
                        <TextField
                            className="admin-login-form-field"
                            label="Email"
                            type="email"
                            value={email}
                            onChange={this.handleEmailChange}
                            error={Boolean(error)}
                            required
                            fullWidth
                            autoComplete="email"
                            disabled={loading}
                        />
                        <TextField
                            className="admin-login-form-field"
                            label="Password"
                            type="password"
                            value={password}
                            onChange={this.handlePasswordChange}
                            error={Boolean(error)}
                            required
                            fullWidth
                            autoComplete="current-password"
                            disabled={loading}
                        />
                    </ThemeProvider>
                    {error && (
                        <p className="admin-login-form-error" role="alert">
                            {error}
                        </p>
                    )}
                    <div className="admin-login-form-actions">
                        <SubmitButton type="submit" disabled={!canSubmit}>
                            {loading ? "Signing in…" : "Sign in"}
                        </SubmitButton>
                    </div>
                </form>
            </div>
        );
    }
}
